namespace TabAurous.Production {
    export interface JobWorkSettlementRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        PartyId?: number;
        LedgerName?: string;
        ProductTypeId?: number;
        Weight?: number;
        KnockOff?: number;
        UserId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: JobWorkSettlementDetailsRow[];
    }

    export namespace JobWorkSettlementRow {
        export const idProperty = 'TransId';
        export const localTextPrefix = 'Production.JobWorkSettlement';
        export const deletePermission = 'Production:JobWorkSettlement:Delete';
        export const insertPermission = 'Production:JobWorkSettlement:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:JobWorkSettlement:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            ProductTypeId = "ProductTypeId",
            Weight = "Weight",
            KnockOff = "KnockOff",
            UserId = "UserId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details"
        }
    }
}
